import React from 'react';
import styles from './Loader.module.css';

export default function Loader({ size = 48, text = 'Loading...' }) {
  return (
    <div className={styles.loaderWrapper}>
      <div
        className={styles.spinner}
        style={{ width: size, height: size }}
        aria-label="Loading Spinner"
      ></div>
      {text && <p className={styles.loaderText}>{text}</p>}
    </div>
  );
}
